import { getModifiedResourcesForTest } from '@helsenorge/framework-utils/resources';
import resources from './HN.CoreFrontend.NPM.Packages.CMS.nb-NO.json';
export function getResourcesTestHelper() {
    return getModifiedResourcesForTest(resources);
}
